import { CartAddEvent, CartErrorEvent } from '@theme/events';

/**
 * Wires .awp_recommendation-card in 'direct' add_behavior mode: grind select
 * swaps the card's active variant, the Add button posts it straight to cart.
 * Document-delegated so it works for any number of cards, added or morphed
 * in at any time, with no per-card setup required.
 */

function cartSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) {
      ids.push(el.dataset.sectionId);
    }
  });
  return ids;
}

document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.classList.contains('awp_recommendation-card__grind')) return;
  const card = select.closest('.awp_recommendation-card');
  if (card instanceof HTMLElement) card.dataset.variantId = select.value;
});

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const btn = target?.closest('button.awp_recommendation-card__add');
  if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;

  const card = btn.closest('.awp_recommendation-card');
  const variantId = card instanceof HTMLElement ? card.dataset.variantId : null;
  if (!variantId) return;

  event.preventDefault();
  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Adding…';

  const params = new URLSearchParams({ id: variantId, quantity: '1' });
  const sectionIds = cartSectionIds();
  if (sectionIds.length > 0) params.append('sections', sectionIds.join(','));

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        Accept: '*/*',
      },
      body: params.toString(),
    });
    const result = await response.json();

    if (result.status) {
      btn.dispatchEvent(new CartErrorEvent('', result.message, result.description, result.errors));
      return;
    }

    const cart = await fetch('/cart.js').then((r) => r.json());

    btn.dispatchEvent(
      new CartAddEvent({}, '', {
        didError: false,
        source: 'awp-recommendation-card',
        itemCount: cart.item_count,
        variantId,
        sections: result.sections,
      })
    );

    const drawer = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  } catch (error) {
    console.error('AWP Recommendation Card: Cart add error', error);
  } finally {
    btn.disabled = false;
    btn.textContent = originalText;
  }
});
